export enum ViewStatusEnum {
    Form,
    Grid
}